import React from 'react'
import { Link, NavLink ,useLocation,useParams} from 'react-router-dom';
import './style.less'
const ProductDrop = (props)=>{
    const productList = [
        {
            list:[
                {title:'Computing Power Rental',path:'/product'},
            ]
        },
        {
            list:[
                {title:'Blockchain Infrastructure',path:'/decentralized/Efficient'},
                {title:'Decentralized Applications',path:'/decentralized/Empowering'},
                {title:'Cross-Chain Solutions',path:'/decentralized/Breaking'},
            ]
        }
    ]
    const params = useParams()
    console.log(params)
    return <div className='product_drop'>
                    <div className="product_cube">
                    {
                        productList.map(val=>{
                            return <div className="product_classfiy">
                            
                                        <div className='product_list'>
                                            {
                                                val.list.map(products=>{
                                                    return <div className="product_item">
                                                        <Link to={products.path}>
                                                            {products.title}
                                                        </Link>
                                                    </div>
                                                })
                                            }                       
                                        </div>
                                
                            </div>
                            
                        })
                    }
                    </div>
    </div>
}
export default ProductDrop